import { createStore } from "redux";
import DefaultReducer from "./Reducers/DefaultReducer";

function configureStore(state = { currentPageName : "Home", currentRoutePath : "/"}) {
  return createStore(DefaultReducer,state);
}

export default configureStore;